import styled from "styled-components";
import Image from "../Image";

export const Img = styled(Image)`
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
`;
